import { createGlobalStyle } from 'styled-components';

export default createGlobalStyle`
@import url('https://fonts.googleapis.com/css?family=Roboto:100,400,700|Montserrat:100,400,700&display=swap');

/* 15 76 129 pantone do ano rgb */

  *{
    margin: 0;
    padding: 0;
    outline: 0;
    box-sizing:border-box;
  }

  *:focus {
    outline: 0;
  }

  html, body, #root {
    height: 100%;
  }

  @media screen and (max-width: 630px) {
    header .sbfv-logo img{
      width: 100%;
    }
  }
  @media screen and (max-width: 850px) {
    table {
      display: block;
      overflow: auto;
    }
  }
  body {
    -webkit-font-smoothing: antialiased;
  }

  body, input, button {
    font: 14px 'Roboto', sans-serif;
  }

  a {
    text-decoration:none;
  }

  ul {
    list-style: none;
  }

  button {
    cursor: pointer;
  }

  .page-loader {
    position: absolute;
    display: flex;
    justify-content: center;
    align-items: center;
    top: 0;
    bottom: 0;
    left: 0%;
    right: 0;
  }

`;
